import { render } from "./StackRequestAdd.vue?vue&type=template&id=2d7564f4"
import script from "./StackRequestAdd.vue?vue&type=script&lang=js"
export * from "./StackRequestAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__